var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pb-offset ma-0"},[_c('standard-smtp',{staticClass:"pb-4"}),_c('pec-smtp',{staticClass:"pb-4"}),(_vm.isPecMassiveEnabled)?_c('pec-massive-smtp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }